import React from 'react';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
import HeroBannerContent from './heroBannerContent';

const HeroBannerComponent = React.memo(({
	fromGradPackages,
	pageContentData = {},
	scrollPosition,
	isDegreeSelected,
	heading,
	firstPackageName,
	hsPaymentPromo,
	packageGroupData,
	popularPackage,
	altImage,
	hsRepAnnouncement,
	repMessage,
	googleAnalytics
}) => {
	const bannerRelatedContent = pageContentData?.relatedContent
	const isSkinnyBanner = bannerRelatedContent && !bannerRelatedContent?.heading
	const { imageURL, imageSrcSet, imageAltText } = {
		imageURL: bannerRelatedContent
			? bannerRelatedContent?.imageUrl?.xl
			: pageContentData?.imageUrl?.md,
		imageSrcSet: bannerRelatedContent
			? bannerRelatedContent?.imageUrl?.xl
			: pageContentData?.imageUrl?.xl,
		imageAltText: bannerRelatedContent
			? bannerRelatedContent?.imageAlt
			: pageContentData?.imgAltText
	}

	return !!Object.keys(pageContentData).length && (
		<>
			<div className={`product-categories ${isSkinnyBanner ? "skinnyBanner": ""}`}>
				<div className={`mb-3 ${isSkinnyBanner ? "" : "row mx-2"}`}>
					<div className={`container-fluid ${isSkinnyBanner ? '' : 'school-banner'}`}>
						<div className="img-wrapper group-name">
							<picture>
								<source media="(min-width: 1024px)" srcSet={imageSrcSet} />
								<LazyLoadImage
									src={imageURL}
									alt={imageAltText}
									scrollPosition={scrollPosition}
									className={`${isSkinnyBanner ? "skinnyBannerImage" : ""}`}
								/>
							</picture>
						</div>
						{!isSkinnyBanner && (
							<HeroBannerContent
								relatedContent={bannerRelatedContent}
								isDegreeSelected={isDegreeSelected}
								hsPaymentPromo={hsPaymentPromo}
								heading={heading}
								pageContentDataHeading={pageContentData.heading}
								firstPackageName={firstPackageName}
								packageGroupProducts={packageGroupData?.products}
								fromGradPackages={fromGradPackages}
								popularPackage={popularPackage}
								altImage={altImage}
								hsRepAnnouncement={hsRepAnnouncement}
								repMessage={repMessage}
								googleAnalytics={googleAnalytics}
							/>
						)}
					</div>
				</div>
			</div>
		</>
	)
})

export default trackWindowScroll(HeroBannerComponent)